import { createActionTypes } from "../../helpers/utils/createActionTypes"

export const REGION = {
    GET_LIST: createActionTypes("GET_LISTA_REGION"),
    GET_ITEM: createActionTypes("GET_REGION"),
    SAVE_ITEM: createActionTypes("SAVE_REGION"),

    LOAD_EMPTY: "LOAD_EMPTY_REGION",
    CLEAN_MESSAGE: "CLEAN_MESSAGE_REGION",
    CHANGE_PAGE_SIZE_REGION: "CHANGE_PAGE_SIZE_REGION"
}